import React, { createContext, useContext, useCallback } from 'react';

import logger from '../utils/logger';
import logError from '../utils/logError';

import { useSnackbar } from './SnackbarContext';
import { useTranslation } from './TranslationContext';

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const { openSnackbar } = useSnackbar();
  const { translate } = useTranslation();
  const handleError = useCallback(
    (error, errorMessage = translate('errorContext.tryLater')) => {
      logger.error(logError(error));
      setTimeout(() => {
        openSnackbar('error', errorMessage);
      }, 500);
    },
    [openSnackbar, translate],
  );

  return <ErrorContext.Provider value={{ handleError }}>{children}</ErrorContext.Provider>;
};

export const useError = () => {
  return useContext(ErrorContext);
};

export { ErrorContext };
